import { gql } from 'graphql-tag';
import {
  specificResourceRequestWithAllocationsFragment,
  specificProjectFragment
} from '~/modules/resourcing/common/fragments';

const resourceRequestQuery = gql`
  query Eager_getResourceRequest($id: String!) {
    resourceRequest(id: $id) {
      ...SpecificResourceRequestWithAllocation
      project {
        permittedActionUris
        ...SpecificProjectFragment
      }
    }
  }
  ${specificResourceRequestWithAllocationsFragment}
  ${specificProjectFragment}
`;

export default resourceRequestQuery;
